<template>
  <main id="main">
    <Loading :isProcessing="isProcessing"></Loading>
    <div class="l-contents">
      <h1 class="l-pageTitle">診断項マスタ編集</h1>
      <div class="l-contentsBox">
        <table class="l-form-table">
          <caption>診断項マスタ</caption>
          <tr>
            <th class="v-middle"><span>条名称</span></th>
            <td class="v-middle">
              <span style="padding-left: 20px;">{{ diagSubSection.diagSection.sortOrder }}. {{ diagSubSection.diagSection.sectionNm }}</span>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>項名称</span></th>
            <td class="v-middle">
              <div class="l-inputAccount" style="width:100%;">
                <TextBox v-model="$v.diagSubSection.$model.subSectionNm" @input="$v.diagSubSection.$touch()" />
                <ValidationErrorMessage v-show="$v.diagSubSection.subSectionNm.$error" validation="required" />
              </div>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>項番号（並び順）</span></th>
            <td class="v-middle">
              <div class="l-inputAccount">{{ diagSubSection.sortOrder ? diagSubSection.sortOrder : '最後尾に追加されます' }}</div>
            </td>
          </tr>
          <tr v-if="isAllPermission">
            <th class="v-middle"><span>Excel項番号</span></th>
            <td class="v-middle">
              <div class="l-inputAccount">
                <TextBox v-model="$v.diagSubSection.$model.xlsSubSectionNo" @input="$v.diagSubSection.$touch()" />
                <ValidationErrorMessage v-show="$v.diagSubSection.xlsSubSectionNo.$error && !$v.diagSubSection.xlsSubSectionNo.required" validation="required" />
              </div>
            </td>
          </tr>
        </table>
        <div class="l-contentsBox__bottom" style="text-align: center;">
          <div class="btn-basic is-inlne mt-20 is-primary js-savebtn" @click="register()" :disabled="isProcessing"><a>更新</a></div>
        </div>
      </div>
      <div class="l-contentsBox" v-if="subSectionId">
        <div style="display: flex; justify-content: flex-end;">
          <div class="btn-basic is-inlne is-primary">
            <button v-if="!canDrag" @click="canDrag = true">並び順を変更する</button>
            <button v-if="canDrag" @click="fixSortOrder()">並び順を確定する</button>
          </div>
        </div>
        <table class="l-form-table">
          <caption>診断項目マスタ</caption>
          <tr>
            <td class="v-middle">&nbsp;</td>
            <td class="v-middle">
              <button v-if="!canDrag" class="link-arrow" @click="goItemNew()">新規追加</button>
            </td>
          </tr>
          <tr v-for="(diagItem, index) in diagSubSection.diagItems"
              :key="diagItem.itemId"
              :draggable="canDrag"
              @dragstart="dragIndex = index"
              @dragenter="changeDiagItemOrder(index)">
            <td class="v-middle">&nbsp;</td>
            <td class="v-middle">
              <div style="display: flex; align-items: center;">
                <button v-if="!canDrag" class="link-arrow" @click="goItemEdit(diagItem.itemId)" style="white-space: nowrap; margin-right: 10px;">編集</button>
                <span v-if="!canDrag" style="white-space: nowrap; margin-right: 15px;">{{ diagItem.sortOrder }}</span>
                <span v-if="canDrag" style="margin-right: 20px">三</span>
                <span v-if="canDrag" style="margin-right: 15px">{{ index + 1 }}</span>
                <span style="white-space: pre-line;">{{ diagItem.checkItem }}</span>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </main>
</template>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import TextBox from '@/components/parts/form/TextBox.vue';
import ValidationErrorMessage from '@/components/parts/form/ValidationErrorMessage.vue';
import { required } from 'vuelidate/lib/validators';
import constant from '@/const';

export default {
  components: {
    Loading,
    TextBox,
    ValidationErrorMessage,
  },
  data() {
    return {
      isProcessing: false,
      diagSubSection: {
        subSectionNm: '',
        sortOrder: null,
        diagItems: [],
        diagSection: {
          sectionNm: '',
        }
      },
      selectPatternList: constant.DIAG_SUB_SECTION_SELECT_PATTERN,
      isAllPermission: false,
      canDrag: false,
      dragIndex: null,
    }
  },
  validations: {
    diagSubSection: {
      subSectionNm: { required },
      xlsSubSectionNo: { required },
    }
  },
  computed: {
    subSectionId() {
      return this.$store.getters['master/getSubSectionId'];
    },
    sectionId() {
      return this.$store.getters['master/getSectionId'];
    }
  },
  created: async function() {
    this.isProcessing = true;
    const authority = await this.$store.dispatch('auth/getAuthority')
    this.isAllPermission = authority.isAllPermission;

    await this.getDiagSubSectionEdit(this.subSectionId);
    this.$nextTick(() => {
      this.isProcessing = false;
    });
  },
  methods: {
    async getDiagSubSectionEdit(subSectionId) {
      let res = await this.$axios.post('/ld/api/master/diag/getDiagSubSectionEdit', {
        subSectionId : subSectionId,
        sectionId: this.sectionId,
      });
      if (res) {
        this.diagSubSection = res.data.diagSubSection;
      }
    },
    async register() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.isProcessing = true;
        let res = await this.$axios.post('/ld/api/master/diag/storeDiagSubSection', {
          diagSubSection: this.diagSubSection,
          sectionId: this.sectionId,
        });
        if (res.status === 200) {
          this.$toast.info('登録が完了しました');
          if (this.$route.name === 'diag-sub-section-master-new') {
            this.$store.dispatch('master/setSubSectionId', res.data.diagSubSection.subSectionId);
            this.$router.push({ name: 'diag-sub-section-master-edit' });
          }
          await this.getDiagSubSectionEdit(res.data.diagSubSection.subSectionId);
      } else {
          this.$toast.error(res.data.message);
        }
        this.isProcessing = false;
      }
    },
    goItemEdit(itemId) {
      this.$store.dispatch('master/setItemId', itemId);
      this.$router.push({ name: 'diag-item-master-edit' });
    },
    goItemNew() {
      this.$store.dispatch('master/setItemId', null);
      this.$router.push({ name: 'diag-item-master-new' });
    },
    changeDiagItemOrder(index) {
      if (index === this.dragIndex) return;
      const deleteElement = this.diagSubSection.diagItems.splice(this.dragIndex, 1)[0];
      this.diagSubSection.diagItems.splice(index, 0, deleteElement);
      this.dragIndex = index;
    },
    async fixSortOrder() {
      this.canDrag = false;

      this.diagSubSection.diagItems = this.diagSubSection.diagItems.map((di, index) => {
        di.sortOrder = index + 1;
        return di;
      });

      this.isProcessing = true;
      const res = await this.$axios.post('/ld/api/master/diag/storeDiagItemSortOrder', {
        diagItems: this.diagSubSection.diagItems,
      });
      if (res.status === 200) {
        this.$toast.info('登録が完了しました');
      } else {
        this.$toast.error(res.data.message);
      }
      this.isProcessing = false;
    },
  }
}
</script>
